// Same focus ring as inputtext: Aura's textarea reads the formField focus ring,
// which is none, so a focused textarea looked different from a focused input.
export const textareaTheme = {
  colorScheme: {
    light: {
      root: {
        focusRing: {
          width: '1px',
          style: 'solid',
          color: 'var(--surface-accent-main)',
          offset: '0',
          shadow: 'none'
        }
      }
    },
    dark: {
      root: {
        focusRing: {
          width: '1px',
          style: 'solid',
          color: 'var(--surface-accent-main)',
          offset: '0',
          shadow: 'none'
        }
      }
    }
  }
};
